/**
 * jc-blog.js
 * Upload to: Assets/jc-blog.js
 * Used by: sections/blog-index.liquid
 *
 * Handles:
 *  - Topic pill active state based on URL
 *  - Newsletter form feedback (Shopify handles the POST, this handles UX)
 */

(function () {
  'use strict';

  // ── TOPIC PILLS: set active state from URL ──────────────────────────────
  var pills = document.querySelectorAll('.jc-topic-pill');
  var currentPath = window.location.pathname;
  var currentSearch = window.location.search;

  pills.forEach(function (pill) {
    var pillHref = pill.getAttribute('href') || '';

    // Remove active from all
    pill.classList.remove('active');

    // "All articles" pill — active when no tag in URL
    if (
      pillHref.indexOf('/tagged/') === -1 &&
      currentPath.indexOf('/tagged/') === -1
    ) {
      pill.classList.add('active');
    }

    // Tagged pill — active when URL contains the same tag slug
    if (
      pillHref.indexOf('/tagged/') !== -1 &&
      currentPath.indexOf('/tagged/') !== -1
    ) {
      var pillTag = pillHref.split('/tagged/')[1];
      var urlTag = currentPath.split('/tagged/')[1];
      if (pillTag && urlTag && pillTag === urlTag) {
        // Remove from "all" pill first
        pills[0] && pills[0].classList.remove('active');
        pill.classList.add('active');
      }
    }
  });

  // ── NEWSLETTER FORM: smooth scroll to success message ──────────────────
  var nlForm = document.getElementById('jc-blog-newsletter');
  if (nlForm) {
    var successMsg = nlForm.querySelector('.jc-nl-success');
    if (successMsg) {
      successMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // ── IMAGE LAZY LOAD FALLBACK for older browsers ─────────────────────────
  if ('loading' in HTMLImageElement.prototype) {
    // Native lazy loading supported — nothing to do
  } else {
    // Intersection Observer fallback
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            observer.unobserve(img);
          }
        });
      }, { rootMargin: '200px 0px' });

      lazyImages.forEach(function (img) { observer.observe(img); });
    }
  }

})();

/* =========================================================
   jc-blog pagination helper
   Append to the END of assets/jc-blog.js (or upload separately
   and add {{ 'jc-blog-pagination.js' | asset_url | script_tag }}).
 
   Pure progressive enhancement — the pagination links are real
   <a href> links and work with JS disabled. This only:
     1. moves keyboard focus to the article list after a page change
     2. shows a "loading" state so a slow page change feels responsive
   ========================================================= */
(function () {
  'use strict';
 
  function focusArticles() {
    if (window.location.hash !== '#jc-articles') return;
    var target = document.getElementById('jc-articles');
    if (!target) return;
    // Let the browser finish its native hash jump first, then take focus
    // so screen readers announce the new list instead of the page top.
    window.requestAnimationFrame(function () {
      target.focus({ preventScroll: true });
    });
  }
 
  function bindLoadingState() {
    var nav = document.querySelector('.jc-pagination');
    if (!nav) return;
 
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || event.metaKey || event.ctrlKey) return;
      nav.classList.add('is-loading');
    });
 
    // Clear the state if the visitor comes back via the back button (bfcache)
    window.addEventListener('pageshow', function () {
      nav.classList.remove('is-loading');
    });
  }
 
  function init() {
    focusArticles();
    bindLoadingState();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================
   jc-blog pagination helper
   Append to the END of assets/jc-blog.js (or upload separately
   and add {{ 'jc-blog-pagination.js' | asset_url | script_tag }}).
 
   Pure progressive enhancement — the pagination links are real
   <a href> links and work with JS disabled. This only:
     1. moves keyboard focus to the article list after a page change
     2. shows a "loading" state so a slow page change feels responsive
   ========================================================= */
(function () {
  'use strict';
 
  function focusArticles() {
    if (window.location.hash !== '#jc-articles') return;
    var target = document.getElementById('jc-articles');
    if (!target) return;
    // Let the browser finish its native hash jump first, then take focus
    // so screen readers announce the new list instead of the page top.
    window.requestAnimationFrame(function () {
      target.focus({ preventScroll: true });
    });
  }
 
  function bindLoadingState() {
    var nav = document.querySelector('.jc-pagination');
    if (!nav) return;
 
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || event.metaKey || event.ctrlKey) return;
      nav.classList.add('is-loading');
    });
 
    // Clear the state if the visitor comes back via the back button (bfcache)
    window.addEventListener('pageshow', function () {
      nav.classList.remove('is-loading');
    });
  }
 
  function init() {
    focusArticles();
    bindLoadingState();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();